<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >
            <span>Banner管理</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">Banner管理</h1>
            <Msg :message="message" :is_error="is_error"></Msg>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <!-- DataTales Example -->
            <div class="card shadow mb-4" v-if="!loading">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Update" >儲存</button>
              </div>
              <div class="card-body">
                
                <div class="card col-12 offset-md-2 col-md-8 p-0 mt-3" v-for="(item) in images" :key="item.id" :id="item.id">
                  <div class="card-header py-3">
                    <h6>Banner {{item.id}}  <span class="remind banner-p" style="font-size: 0px;">若有上傳圖片，請同時將電腦版與手機版都上傳</span></h6>
                   
                  </div>
                  
                  <div class="card-body row">
                                      
                    <div class="form-group col-6">
                      <h6>電腦版圖片</h6>
                      <img class="card-img-top" :src="item.pc.src">
                      <label class="btn btn-info mt-2">
                        <input  style="display:none;" type="file" accept="image/*" @change="PreviewImage"  name="pc" :data-id="item.id">
                        <i class="far fa-file-image"></i> 上傳圖片
                      </label>

                      <label>Width:<b>{{item.pc.width}}</b>px Height:<b>{{item.pc.height}}</b>px</label>
             
                      <div class="form-group" v-if="!item.pc.is_upload">
                        <p>Progress: {{item.pc.uploadValue.toFixed()+"%"}} 
                        <progress id="progress" :value="item.pc.uploadValue" max="100" style="width:100%"></progress>  </p>
                      </div>
                
                    </div>

                    <div class="form-group col-6">
                      <h6>手機版圖片</h6>
                      <img class="card-img-top" :src="item.mobile.src">
                      <label class="btn btn-info mt-2">
                        <input  style="display:none;" type="file" accept="image/*" @change="PreviewImage" name="mobile" :data-id="item.id" >
                        <i class="far fa-file-image"></i> 上傳圖片
                      </label>

                      <label>Width:<b>{{item.mobile.width}}</b>px Height:<b>{{item.mobile.height}}</b>px</label>
             
                      <div class="form-group" v-if="!item.mobile.is_upload">
                        <p>Progress: {{item.mobile.uploadValue.toFixed()+"%"}} 
                        <progress id="progress" :value="item.mobile.uploadValue" max="100" style="width:100%"></progress>  </p>
                      </div>
                
                    </div>
                    <div class="form-group col-12">
                      <label for="link" class="col-sm-2 col-form-label">連結</label>
                      <div class="col-sm-12">
                        <input type="text" class="form-control" id="link" v-model="item.link">
                      </div>
                    </div>
                  </div>
                </div>
                

              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>
<style scoped>
  .title {
    font-weight: bold;
    border-bottom: 1px solid #e3e6f0;
  }
  .item {
    border-bottom: 1px solid #e3e6f0;
    cursor: pointer;
  }
  
</style>
<script>
import {fb, db } from '../firebase'
export default {
  name: 'Banner',
  data () {
    return {
      images:[],
      disabled:false,
      loading:true,
      message:'',
      is_error:false
    }
  },
  mounted() {
    this.Get();
  },
  watch: {
    message:function() {
      if ( !this.is_error ) {
        var vm = this;
        setTimeout(function(){ vm.message = '' }, 2000);
      }
    } 
  },
  methods: {
    msg(msg, is_error){
      this.message = msg;
      this.is_error = is_error;
    },
    Get(){

      db.collection('banner').get().then((querySnapshot) => {

        querySnapshot.forEach((doc) => {  
            var data = doc.data();
            var tmp = {
              id:     doc.id,
              link:   data.link,
              pc:{
                src: data.pc.src,
                width:data.pc.width,
                height:data.pc.height,
                name:'',
                uploadValue:100,
                is_upload:true
              },
              mobile:{
                src: data.mobile.src,
                width:data.mobile.width,
                height:data.mobile.height,
                name:'',
                uploadValue:100,
                is_upload:true
              }
            }
            this.images.push(tmp);
        });

        this.loading = false;

      }).catch((error) => {
        console.log("Error getting document:", error);
        this.message = '發生錯誤，請聯絡管理員';
        this.is_error = true;
      });


    },
    PreviewImage(event) {
      
      var index = event.target.getAttribute("data-id")
      var name = event.target.getAttribute("name")

      var tmp = {};
      if ( name == 'pc') {
        this.images[index-1].pc.is_upload = false;
        this.images[index-1].pc.uploadValue = 0;
        this.images[index-1].pc.name = event.target.files[0].name;
        this.images[index-1].pc.src = URL.createObjectURL(event.target.files[0]);

        tmp.name = 'pc';
      } else {
        this.images[index-1].mobile.is_upload = false;
        this.images[index-1].mobile.uploadValue = 0;
        this.images[index-1].mobile.name = event.target.files[0].name;
        this.images[index-1].mobile.src = URL.createObjectURL(event.target.files[0]);

        tmp.name = 'mobile';
      } 
      tmp.imageData =  event.target.files[0];
      tmp.id = index;
      tmp.src = URL.createObjectURL(event.target.files[0]);
     
      var img = new Image();
      var vm = this;
      img.onload = function () {
        URL.revokeObjectURL(tmp.src);
        tmp.height = this.height;
        tmp.width = this.width;
      };
      img.src = tmp.src;

      this.onUpload(tmp);
    },
    onUpload(tmp){

      const storageRef= fb.storage().ref('banner/'+tmp.imageData.name).put(tmp.imageData);

      storageRef.on('state_changed',
      snapshot=>{
        if ( tmp.name == 'pc') this.images.find(x => x.id === tmp.id).pc.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        else this.images.find(x => x.id === tmp.id).mobile.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, 
      error => {
        console.log(error.message)
        this.message = '上傳檔案發生錯誤';
        this.is_error = true;
      }, 
      () => {
        if ( tmp.name == 'pc') this.images.find(x => x.id === tmp.id).pc.uploadValue=100;
        else this.images.find(x => x.id === tmp.id).mobile.uploadValue=100;
        
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{

          if ( tmp.name == 'pc') {
            this.images.find(x => x.id === tmp.id).pc.src =url;
            this.images.find(x => x.id === tmp.id).pc.is_upload = true;
            this.images.find(x => x.id === tmp.id).pc.height = tmp.height;
            this.images.find(x => x.id === tmp.id).pc.width = tmp.width;
          } else {
            this.images.find(x => x.id === tmp.id).mobile.src =url;
            this.images.find(x => x.id === tmp.id).mobile.is_upload = true;
            this.images.find(x => x.id === tmp.id).mobile.height = tmp.height;
            this.images.find(x => x.id === tmp.id).mobile.width = tmp.width;
          }
          console.log('success');
        });
        
      
      }
      );
    },
    Update() {
      var check = true
      var datas = [];
      this.Beforesend();
      this.images.forEach(function(value, index, array){

       
        if ( value.pc.src != '' ) {
          if ( value.mobile.src == ''){
            var id = index +1 ;
            $("#"+id).find('.banner-p').css("font-size","14px");
            check = false;
          } else { 
            $("#"+id).find('.banner-p').css("font-size","0px");
            check = true;
          }
        }
        
        if ( value.mobile.src != '' ) {
          if ( value.pc.src == ''){
            $("#"+id).find('.banner-p').css("font-size","14px");
            check = false;
          }  else {
            $("#"+id).find('.banner-p').css("font-size","0px");
            check = true;
          }
        }

        var item = {
          id:value.id,
          link:   value.link,
          pc:{
            src: value.pc.src,
            width:value.pc.width,
            height:value.pc.height,
            name:value.pc.name,
          },
          mobile:{
            src: value.mobile.src,
            width:value.mobile.width,
            height:value.mobile.height,
            name:value.mobile.name,
          }
        }


        datas.push(item);
      });


      if ( check ) {
        var batch = db.batch();
        datas.forEach(function(value, index, array){
          var sfRef = db.collection('banner').doc(value.id);
          batch.set(sfRef, value);
        });

        batch.commit().then(() => {
          alert("更新成功");
          this.Aftersend();
        });
      
      } else {
        this.Aftersend();
        alert("更新失敗，若有上傳圖片，請同時將電腦版與手機版都上傳!")
      }

    },
    PreviewFiles(event) {
      var index = event.target.id;
      this.datas[index].src = URL.createObjectURL(event.target.files[0]);

      var tmp = {};
      tmp.imageData =  event.target.files[0];
      tmp.uploadValue = 0;
      tmp.is_upload = false;
      tmp.caption = event.target.files[0].name;
      tmp.name = event.target.files[0].name ;
      tmp.src = URL.createObjectURL(event.target.files[0]);
      
      var _URL = window.URL || window.webkitURL;
      var img = new Image();
      var objectUrl = _URL.createObjectURL(event.target.files[0]);

      var vm = this;
      img.onload = function () {

          _URL.revokeObjectURL(objectUrl);
          console.log( vm.datas[index].width );

          vm.datas[index].height = this.height;
          vm.datas[index].width = this.width;

          console.log( vm.datas[index].width );
      };
       img.src = objectUrl;
    }

  }
}
</script>
<style scoped>
label span, .remind{
  color:#BE0000
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue